import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Gift, Copy, ArrowUpRight } from "lucide-react";
import { useLang } from "../LanguageContext";
import { useAuth } from "../AuthContext";

export default function BirthdayBanner({ compact = false }) {
  const { t, lang } = useLang();
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);

  const bday = user?.birthday;
  if (!user || !bday?.is_birthday_month || !bday.code) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(bday.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  // Format expiry
  let expiry = "";
  try {
    const d = new Date(bday.expires_at);
    // subtract 1 day to display "valid through"
    d.setDate(d.getDate() - 1);
    expiry = d.toLocaleDateString(lang === "fr" ? "fr-FR" : "en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch {}

  return (
    <div
      data-testid="birthday-banner"
      className={`relative overflow-hidden border border-primary ${compact ? "p-6" : "p-8 md:p-10"} bg-gradient-to-br from-primary/20 to-accent/10`}
    >
      <div className="absolute -top-8 -right-8 text-primary/10 pointer-events-none">
        <Gift size={140} strokeWidth={0.6} />
      </div>
      <div className="relative">
        <p className="qw-overline mb-3 text-primary flex items-center gap-2">
          <Gift size={12} strokeWidth={1.4} /> {t.birthday.title}
        </p>
        <h3 className={`font-serif ${compact ? "text-2xl" : "text-3xl md:text-4xl"} text-foreground mb-2 font-light`}>
          {t.birthday.offer}
        </h3>
        <p className="text-sm text-muted-foreground mb-6">{t.birthday.subtitle}</p>

        <div className="border border-primary/50 px-5 py-4 mb-5 flex items-center justify-between gap-4 bg-background/40">
          <div>
            <p className="text-[0.65rem] tracking-[0.25em] uppercase text-muted-foreground mb-1">{t.birthday.yourCode}</p>
            <p data-testid="birthday-code" className="font-serif text-xl text-primary qw-num tracking-wider">{bday.code}</p>
          </div>
          <button
            onClick={copy}
            data-testid="birthday-copy-btn"
            className="qw-btn qw-btn-outline !py-2 !px-4 !text-[0.65rem]"
          >
            <Copy size={12} strokeWidth={1.2} /> {copied ? t.birthday.copied : t.birthday.copyCode}
          </button>
        </div>

        {expiry && (
          <p className="text-xs text-muted-foreground tracking-wider mb-6">
            {t.birthday.expires} <span className="text-primary qw-num">{expiry}</span>
          </p>
        )}

        <Link
          to="/booking"
          data-testid="birthday-book-btn"
          className="qw-btn qw-btn-primary !text-[0.7rem] !py-2.5 !px-5"
        >
          {t.birthday.bookNow} <ArrowUpRight size={12} strokeWidth={1.2} />
        </Link>
      </div>
    </div>
  );
}
